module.exports = __webpack_public_path__ + "img/information.e1b39003.svg";